function _kmLoad(src, cb) {
  var s = document.createElement('script');
  s.src = src; s.onload = cb;
  document.head.appendChild(s);
}
_kmLoad('https://cdn.jsdelivr.net/npm/d3@7/dist/d3.min.js', function() {
  _kmLoad('https://cdn.jsdelivr.net/npm/topojson-client@3/dist/topojson-client.min.js', function() {
    _kmInit();
  });
});
function _kmInit() {

const CFG = {
  detailZoom: 8,
  detailExit: 7,
  searchBase: "https://komorebiworld.com/search",
  searchLang: "fr",
  paris: [2.3522, 48.8566],
  countryImgBase: "https://cdn.shopify.com/s/files/1/0662/9412/0702/files",
  stateImgBase:   "https://cdn.shopify.com/s/files/1/0662/9412/0702/files",
  regionImgBase:  "https://cdn.shopify.com/s/files/1/0662/9412/0702/files",
  cityImgBase:    "https://cdn.shopify.com/s/files/1/0662/9412/0702/files",
  cityZoom: 2.5,
};

const GEO = {
  world: [
    "https://cdn.jsdelivr.net/gh/nvkelso/natural-earth-vector@master/geojson/ne_110m_admin_0_countries.geojson",
    "https://raw.githubusercontent.com/nvkelso/natural-earth-vector/master/geojson/ne_110m_admin_0_countries.geojson",
  ],
  states: ["https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json"],
  regions: [
    "https://cdn.jsdelivr.net/gh/gregoiredavid/france-geojson@master/regions.geojson",
    "https://raw.githubusercontent.com/gregoiredavid/france-geojson/master/regions.geojson",
  ],
};

const FIPS_STATE = {
  "01":"Alabama","02":"Alaska","04":"Arizona","05":"Arkansas","06":"California",
  "08":"Colorado","09":"Connecticut","10":"Delaware","11":"District of Columbia",
  "12":"Florida","13":"Georgia","15":"Hawaii","16":"Idaho","17":"Illinois",
  "18":"Indiana","19":"Iowa","20":"Kansas","21":"Kentucky","22":"Louisiana",
  "23":"Maine","24":"Maryland","25":"Massachusetts","26":"Michigan","27":"Minnesota",
  "28":"Mississippi","29":"Missouri","30":"Montana","31":"Nebraska","32":"Nevada",
  "33":"New Hampshire","34":"New Jersey","35":"New Mexico","36":"New York",
  "37":"North Carolina","38":"North Dakota","39":"Ohio","40":"Oklahoma",
  "41":"Oregon","42":"Pennsylvania","44":"Rhode Island","45":"South Carolina",
  "46":"South Dakota","47":"Tennessee","48":"Texas","49":"Utah","50":"Vermont",
  "51":"Virginia","53":"Washington","54":"West Virginia","55":"Wisconsin",
  "56":"Wyoming","72":"Puerto Rico",
};

const DEFAULT_HINT = "Survolez un pays · Cliquez pour voir les résultats";
const DETAIL_HINT  = "Cliquez sur une région ou un état pour voir les résultats";
const TOUCH_HINT   = "Touchez un pays pour voir les résultats";

const imgUrl = (base, file, fallback) =>
  (base && file) ? `${base}/${file.replace(/ /g, '_')}` : (fallback ?? null);

const flagCdn      = iso2 => imgUrl(CFG.countryImgBase, COUNTRY_IMG[iso2], `https://flagcdn.com/w320/${iso2.toLowerCase()}.png`);
const searchUrl    = q    => `${CFG.searchBase}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
const stateFlagUrl = abbr => imgUrl(CFG.stateImgBase, STATE_IMG[abbr.toLowerCase()], `https://flagcdn.com/w320/us-${abbr.toLowerCase()}.png`);
const regionFlagUrl = (slug, wikiUrl) => imgUrl(CFG.regionImgBase, REGION_IMG[slug], wikiUrl);
const parisFlagUrl  = () => imgUrl(CFG.regionImgBase, "Paris - Flag Badge.png",
  "https://commons.wikimedia.org/wiki/Special:FilePath/Flag_of_Paris.svg?width=320");

function expandAbbr(s){
  return (s ?? "")
    .replace(/\bRép\.\s*/gi, "République ")
    .replace(/\bNv-/gi, "Nouvelle-")
    .replace(/\bOcc\.\s*/gi, "Occidentale")
    .replace(/\s+/g, " ").trim();
}

function searchTerm(scope, feature, data){
  if (data.search) return data.search;
  if (CFG.searchLang === "en"){
    const p = feature?.properties ?? {};
    if (scope === "country") return p.NAME_EN ?? p.NAME ?? p.ADMIN ?? expandAbbr(data.fr);
    if (scope === "state")   return p.name ?? expandAbbr(data.fr);
  }
  return expandAbbr(data.fr);
}
const countryUrl = (f,d) => searchUrl(searchTerm("country",f,d));
const stateUrl   = (f,d) => searchUrl(searchTerm("state",f,d));
const regionUrl  = (f,d) => searchUrl(searchTerm("region",f,d));

const COUNTRIES = {
  "ZA":{fr:"Afrique du Sud"},"DZ":{fr:"Algérie"},"AO":{fr:"Angola"},"BJ":{fr:"Bénin"},
  "BW":{fr:"Botswana"},"BF":{fr:"Burkina Faso"},"BI":{fr:"Burundi"},"CM":{fr:"Cameroun"},
  "CV":{fr:"Cap-Vert"},"CF":{fr:"Rép. Centrafricaine"},"KM":{fr:"Comores"},
  "CD":{fr:"Congo RDC"},"CG":{fr:"Congo Rep"},"CI":{fr:"Côte d'Ivoire"},
  "DJ":{fr:"Djibouti"},"EG":{fr:"Égypte"},"ER":{fr:"Érythrée"},"SZ":{fr:"Eswatini"},
  "ET":{fr:"Éthiopie"},"GA":{fr:"Gabon"},"GM":{fr:"Gambie"},"GH":{fr:"Ghana"},
  "GN":{fr:"Guinée"},"GW":{fr:"Guinée-Bissau"},"GQ":{fr:"Guinée Équatoriale"},
  "KE":{fr:"Kenya"},"LS":{fr:"Lesotho"},"LR":{fr:"Liberia"},"LY":{fr:"Libye"},
  "MG":{fr:"Madagascar"},"MW":{fr:"Malawi"},"ML":{fr:"Mali"},"MA":{fr:"Maroc"},
  "MU":{fr:"Maurice"},"MR":{fr:"Mauritanie"},"MZ":{fr:"Mozambique"},"NA":{fr:"Namibie"},
  "NE":{fr:"Niger"},"NG":{fr:"Nigeria"},"UG":{fr:"Ouganda"},"RW":{fr:"Rwanda"},
  "ST":{fr:"Sao Tomé-et-Príncipe"},"SN":{fr:"Sénégal"},"SC":{fr:"Seychelles"},
  "SL":{fr:"Sierra Leone"},"SO":{fr:"Somalie"},"SD":{fr:"Soudan"},"SS":{fr:"Soudan du Sud"},
  "TZ":{fr:"Tanzanie"},"TD":{fr:"Tchad"},"TG":{fr:"Togo"},"TN":{fr:"Tunisie"},
  "ZM":{fr:"Zambie"},"ZW":{fr:"Zimbabwe"},

  "AF":{fr:"Afghanistan"},"SA":{fr:"Arabie Saoudite"},"AM":{fr:"Arménie"},
  "AZ":{fr:"Azerbaïdjan"},"BH":{fr:"Bahreïn"},"BD":{fr:"Bangladesh"},"BT":{fr:"Bhoutan"},
  "BN":{fr:"Brunei"},"KH":{fr:"Cambodge"},"CN":{fr:"Chine"},"KP":{fr:"Corée du Nord"},
  "KR":{fr:"Corée du Sud"},"AE":{fr:"Émirats Arabes Unis"},"GE":{fr:"Géorgie"},
  "HK":{fr:"Hong Kong"},"IN":{fr:"Inde"},"ID":{fr:"Indonésie"},"IQ":{fr:"Irak"},
  "IR":{fr:"Iran"},"IL":{fr:"Israël"},"JP":{fr:"Japon"},"JO":{fr:"Jordanie"},
  "KZ":{fr:"Kazakhstan"},"KW":{fr:"Koweït"},"KG":{fr:"Kirghizstan"},"LA":{fr:"Laos"},
  "LB":{fr:"Liban"},"MO":{fr:"Macao"},"MY":{fr:"Malaisie"},"MV":{fr:"Maldives"},
  "MN":{fr:"Mongolie"},"MM":{fr:"Myanmar"},"NP":{fr:"Népal"},"OM":{fr:"Oman"},
  "UZ":{fr:"Ouzbékistan"},"PK":{fr:"Pakistan"},"PS":{fr:"Palestine"},
  "PH":{fr:"Philippines"},"QA":{fr:"Qatar"},"RU":{fr:"Russie"},"SG":{fr:"Singapour"},
  "LK":{fr:"Sri Lanka"},"SY":{fr:"Syrie"},"TW":{fr:"Taïwan"},"TJ":{fr:"Tadjikistan"},
  "TH":{fr:"Thaïlande"},"TL":{fr:"Timor Oriental"},"TM":{fr:"Turkménistan"},
  "TR":{fr:"Turquie"},"VN":{fr:"Viêt Nam"},"YE":{fr:"Yémen"},

  "AG":{fr:"Antigua & Barbuda"},"AR":{fr:"Argentine"},"BS":{fr:"Bahamas"},
  "BB":{fr:"Barbade"},"BZ":{fr:"Belize"},"BO":{fr:"Bolivie"},"BR":{fr:"Brésil"},
  "CA":{fr:"Canada"},"CL":{fr:"Chili"},"CO":{fr:"Colombie"},"CR":{fr:"Costa Rica"},
  "CU":{fr:"Cuba"},"DM":{fr:"Dominique"},"SV":{fr:"El Salvador"},"EC":{fr:"Équateur"},
  "US":{fr:"États-Unis"},"GD":{fr:"Grenade"},"GT":{fr:"Guatemala"},"GY":{fr:"Guyana"},
  "HT":{fr:"Haïti"},"HN":{fr:"Honduras"},"JM":{fr:"Jamaïque"},"MX":{fr:"Mexique"},
  "NI":{fr:"Nicaragua"},"PA":{fr:"Panama"},"PY":{fr:"Paraguay"},"PE":{fr:"Pérou"},
  "DO":{fr:"Rép. Dominicaine"},"KN":{fr:"Saint-Kitts-et-Nevis"},"VC":{fr:"Saint-Vincent"},
  "LC":{fr:"Sainte-Lucie"},"SR":{fr:"Suriname"},"TT":{fr:"Trinité-et-Tobago"},
  "UY":{fr:"Uruguay"},"VE":{fr:"Venezuela"},

  "AL":{fr:"Albanie"},"DE":{fr:"Allemagne"},"AD":{fr:"Andorre"},"AT":{fr:"Autriche"},
  "BY":{fr:"Bélarus"},"BE":{fr:"Belgique"},"BA":{fr:"Bosnie-Herzégovine"},
  "BG":{fr:"Bulgarie"},"CY":{fr:"Chypre"},"HR":{fr:"Croatie"},"DK":{fr:"Danemark"},
  "ES":{fr:"Espagne"},"EE":{fr:"Estonie"},"FI":{fr:"Finlande"},"FR":{fr:"France"},
  "GR":{fr:"Grèce"},"HU":{fr:"Hongrie"},"IE":{fr:"Irlande"},"IS":{fr:"Islande"},
  "IT":{fr:"Italie"},"LV":{fr:"Lettonie"},"LI":{fr:"Liechtenstein"},"LT":{fr:"Lituanie"},
  "LU":{fr:"Luxembourg"},"MK":{fr:"Macédoine du Nord"},"MT":{fr:"Malte"},
  "MD":{fr:"Moldavie"},"MC":{fr:"Monaco"},"XK":{fr:"Kosovo"},"ME":{fr:"Monténégro"},
  "NO":{fr:"Norvège"},"NL":{fr:"Pays-Bas"},"PL":{fr:"Pologne"},"PT":{fr:"Portugal"},
  "CZ":{fr:"Rép. Tchèque"},"RO":{fr:"Roumanie"},"GB":{fr:"Royaume-Uni"},
  "SM":{fr:"Saint-Marin"},"RS":{fr:"Serbie"},"SK":{fr:"Slovaquie"},"SI":{fr:"Slovénie"},
  "SE":{fr:"Suède"},"CH":{fr:"Suisse"},"UA":{fr:"Ukraine"},"VA":{fr:"Vatican"},

  "GL":{fr:"Groenland"},"AQ":{fr:"Antarctique"},

  "AU":{fr:"Australie"},"FJ":{fr:"Fidji"},"MH":{fr:"Îles Marshall"},
  "SB":{fr:"Îles Salomon"},"KI":{fr:"Kiribati"},"FM":{fr:"Micronésie"},
  "NR":{fr:"Nauru"},"NZ":{fr:"Nouvelle-Zélande"},"PW":{fr:"Palaos"},
  "PG":{fr:"Papouasie-Nv-Guinée"},"WS":{fr:"Samoa"},"TO":{fr:"Tonga"},
  "TV":{fr:"Tuvalu"},"VU":{fr:"Vanuatu"},
};

const COUNTRY_IMG = {
  "ZA":"South Africa - Flag Badge.png","DZ":"Algeria - Flag Badge.png",
  "AO":"Angola - Flag Badge.png","BJ":"Benin - Flag Badge.png",
  "BW":"Botswana - Flag Badge.png","BF":"Burkina Faso - Flag Badge.png",
  "BI":"Burundi - Flag Badge.png","CM":"Cameroon - Flag Badge.png",
  "CV":"Cape Verde - Flag Badge.png","CF":"Central African Republic - Flag Badge.png",
  "KM":"Comoros - Flag Badge.png","CD":"Congo Rep Dem - Flag Badge.png",
  "CG":"Congo Rep - Flag Badge.png","CI":"Ivory Coast - Flag Badge.png",
  "DJ":"Djibouti - Flag Badge.png","EG":"Egypt - Flag Badge.png",
  "ER":"Eritrea - Flag Badge.png","SZ":"Eswatini - Flag Badge.png",
  "ET":"Ethiopia - Flag Badge.png","GA":"Gabon - Flag Badge.png",
  "GM":"Gambia - Flag Badge.png","GH":"Ghana - Flag Badge.png",
  "GN":"Guinea - Flag Badge.png","GW":"Guinea Bissau - Flag Badge.png",
  "GQ":"Equatorial Guinea - Flag Badge.png","KE":"Kenya - Flag Badge.png",
  "LS":"Lesotho - Flag Badge.png","LR":"Liberia - Flag Badge.png",
  "LY":"Lybia - Flag Badge.png","MG":"Madagascar - Flag Badge.png",
  "MW":"Malawi - Flag Badge.png","ML":"Mali - Flag Badge.png",
  "MA":"Morocco - Flag Badge.png","MU":"Mauritius - Flag Badge.png",
  "MR":"Mauritania - FLag Badge.png","MZ":"Mozambique - Flag Badge.png",
  "NA":"Namibia - Flag Badge.png","NE":"Niger - Flag Badge.png",
  "NG":"Nigeria - Flag Badge.png","UG":"Uganda - Flag Badge.png",
  "RW":"Rwanda - Flag Badge.png","ST":"Sao Tome & Principe - Flag Badge.png",
  "SN":"Senegal - Flag Badge.png","SC":"Seychelles - Flag Badge.png",
  "SL":"Sierra Leone - Flag Badge.png","SO":"Somalia - Flag Badge.png",
  "SD":"Sudan - Flag Badge.png","SS":"South Sudan - Flag Badge.png",
  "TZ":"Tanzania - Flag Badge.png","TD":"Chad - Flag Badge.png",
  "TG":"Togo - Flag Badge.png","TN":"Tunisia - Flag Badge.png",
  "ZM":"Zambia - Flag Badge.png","ZW":"Zimbabwe - Flag Badge.png",
  "AG":"Antigua & Barbuda - Flag Badge.png","AR":"Argentina - Flag Badge.png",
  "BS":"Bahamas - Flag Badge.png","BB":"Barbados - Flag Badge.png",
  "BZ":"Belize - Flag Badge.png","BO":"Bolivia - Flag Badge.png",
  "BR":"Brazil - Flag Badge.png","CA":"Canada - Flag Badge.png",
  "CL":"Chile - Flag Badge.png","CO":"Colombia - Flag Badge.png",
  "CR":"Costa Rica - Flag Badge.png","CU":"Cuba - Flag Badge.png",
  "DM":"Dominica - Flag Badge.png","SV":"El Salvador - Flag Badge.png",
  "EC":"Ecuador - Flag Badge.png","US":"USA - Flag Badge.png",
  "GD":"Grenada - Flag Badge.png","GT":"Guatemala - Flag Badge.png",
  "GY":"Guyana - Flag Badge.png","HT":"Haiti - Flag Badge.png",
  "HN":"Honduras - Flag Badge.png","JM":"Jamaica - Flag Badge.png",
  "MX":"Mexico - Flag Badge.png","NI":"Nicaragua - Flag Badge.png",
  "PA":"Panama - Flag Badge.png","PY":"Paraguay - Flag Badge.png",
  "PE":"Peru - Flag Badge.png","DO":"Dominican Republic - Flag Badge.png",
  "KN":"Saint Kitts and Nevis - Flag Badge.png",
  "VC":"Saint Vincent and the Grenadines - Flag Badge.png",
  "LC":"Saint Lucia - Flag Badge.png",
  "SR":"Suriname - Flag Badge.png","TT":"Trinidad & Tobago - Flag Badge.png",
  "UY":"Uruguay - Flag Badge.png","VE":"Venezuela - Flag Badge.png",
  "AF":"Afghanistan - Flag Badge.png","SA":"Saudi Arabia - Flag Badge.png",
  "AZ":"Azerbaijan - Flag Badge.png","BH":"Bahrain - Flag Badge.png",
  "BD":"Bangladesh - Flag Badge.png","BT":"Bhutan - Flag Badge.png",
  "BN":"Brunei - Flag Badge.png","KH":"Cambodia - Flag Badge.png",
  "CN":"China - Flag Badge.png","KP":"North Korea - Flag Badge.png",
  "KR":"South Korea - Flag Badge.png","AE":"United Arab Emirates - Flag Badge.png",
  "HK":"Hong Kong SAR - Flag Badge.png","IN":"India - Flag Badge.png",
  "ID":"Indonesia - Flag Badge.png","IQ":"Iraq - Flag Badge.png",
  "IR":"Iran - Flag Badge.png","IL":"Israel - Flag Badge.png",
  "JP":"Japan - Flag Badge.png","JO":"Jordan - Flag BAdge.png",
  "KZ":"Kazakhstan - Flag Badge.png","KW":"Kuwait - Flag Badge.png",
  "KG":"Kyrgyzstan - Flag Badge.png","LA":"Laos - Flag Badge.png",
  "LB":"Lebanon - Flag Badge.png","MO":"Macau SAR - Flag Badge.png",
  "MY":"Malaysia - Flag Badge.png","MV":"Maldives - Flag Badge.png",
  "MN":"Mongolia - Flag Badge.png","MM":"Myanmar - Flag Badge.png",
  "NP":"Nepal - Flag Badge.png","OM":"Oman - Flag Badge.png",
  "UZ":"Uzbekistan - Flag Badge.png","PK":"Pakistan - Flag Badge.png",
  "PS":"Palestine - Flag Badge.png","PH":"Philippines - Flag Badge.png",
  "QA":"Qatar - Flag Badge.png","RU":"Russia - Flag Badge.png",
  "SG":"Singapore - Flag Badge.png","LK":"Sri Lanka - Flag Badge.png",
  "SY":"Syria - Flag Badge.png","TW":"Taiwan - Flag Badge.png",
  "TJ":"Tajikistan - Flag Badge.png","TH":"Thailand - Flag Badge.png",
  "TL":"Timor Leste - Flag Badge.png","TM":"Turkmenistan - Flag Badge.png",
  "TR":"Turkey - Flag Badge.png","VN":"Viet Nam - Flag Badge.png",
  "YE":"Yemen - Flag Badge.png",
  "AL":"Albania - Flag Badge.png","DE":"Germany - Flag Badge.png",
  "AD":"Andora - Flag Badge.png","AT":"Austria - Flag Badge.png",
  "BY":"Belarus - Flag Badge.png","BE":"Belgium - Flag Badge.png",
  "BA":"Bosnia Herzegovina - Flag Badge.png","BG":"Bulgaria - Flag Badge.png",
  "CY":"Cyprus - Flag Badge.png","HR":"Croatia - Flag Badge.png",
  "DK":"Denmark - Flag Badge.png","ES":"Spain - Flag Badge.png",
  "EE":"Estonia - Flag Badge.png","FI":"Finland - Flag Badge.png",
  "FR":"France - Flag Badge.png","GR":"Greece - Flag Badge.png",
  "HU":"Hungary - Flag Badge.png","IE":"Ireland - Flag Badge.png",
  "IS":"Iceland - Flag Badge.png","IT":"Italy - Flag Badge.png",
  "LV":"Latvia - Flag Badge.png","LI":"Liechtenstein - Flag Badge.png",
  "LT":"Lithuania - Flag Badge.png","LU":"Luxembourg - Flag Badge.png",
  "MK":"North Macedonia - Flag Badge.png","MT":"Malta - Flag Badge.png",
  "MD":"Moldova - Flag Badge.png","MC":"Monaco - Flag Badge.png",
  "ME":"Montenegro - Flag Badge.png","NO":"Norway - Flag Badge.png",
  "NL":"Netherlands - Flag Badge.png","PL":"Poland - Flag Badge.png",
  "PT":"Portugal - Flag Badge.png","CZ":"Czech Republic - Flag Badge.png",
  "RO":"Romania - Flag Badge.png","GB":"United Kingdom - Flag Badge.png",
  "SM":"San Marino - Flag Badge.png","RS":"Serbia - Flag Badge.png",
  "SK":"Slovakia - Flag Badge.png","SI":"Slovenia - Flag Badge.png",
  "SE":"Sweden - Flag Badge.png","CH":"Switzerland - Flag Badge.png",
  "UA":"Ukraine - Flag Badge.png","VA":"Vatican - Flag Badge.png",
  "AM":"Armenia - Flag Badge.png","GE":"Georgia - Flag Badge.png",
  "XK":"Kosovo - Flag Badge.png",
  "AU":"Australia - Flag Badge.png","FJ":"Fiji - Flag Badge.png",
  "MH":"Marshall Islands - Flag Badge.png","SB":"Solomon Islands - Flag Badge.png",
  "KI":"Kiribati - Flag Badge.png","FM":"Micronesia - Flag Bagde.png",
  "NR":"Nauru - Flag Badge.png","NZ":"New Zealand - Flag Badge.png",
  "PW":"Palau - Flag Badge.png","PG":"Papua New Guinea - Flag Badge.png",
  "WS":"Samoa - Flag Badge.png","TO":"Tonga - Flag Badge.png",
  "TV":"Tuvalu - Flag Badge.png","VU":"Vanuatu - Flag Badge.png",
  "GL":"Greenland - Flag Badge.png","AQ":"Antarctica - Flag Badge.png",
};

const US_STATES = {
  "Alabama":       {fr:"Alabama",abbr:"al"},
  "Alaska":        {fr:"Alaska",abbr:"ak"},
  "Arizona":       {fr:"Arizona",abbr:"az"},
  "Arkansas":      {fr:"Arkansas",abbr:"ar"},
  "California":    {fr:"Californie",abbr:"ca"},
  "Colorado":      {fr:"Colorado",abbr:"co"},
  "Connecticut":   {fr:"Connecticut",abbr:"ct"},
  "Delaware":      {fr:"Delaware",abbr:"de"},
  "Florida":       {fr:"Floride",abbr:"fl"},
  "Georgia":       {fr:"Géorgie",abbr:"ga"},
  "Hawaii":        {fr:"Hawaï",abbr:"hi"},
  "Idaho":         {fr:"Idaho",abbr:"id"},
  "Illinois":      {fr:"Illinois",abbr:"il"},
  "Indiana":       {fr:"Indiana",abbr:"in"},
  "Iowa":          {fr:"Iowa",abbr:"ia"},
  "Kansas":        {fr:"Kansas",abbr:"ks"},
  "Kentucky":      {fr:"Kentucky",abbr:"ky"},
  "Louisiana":     {fr:"Louisiane",abbr:"la"},
  "Maine":         {fr:"Maine",abbr:"me"},
  "Maryland":      {fr:"Maryland",abbr:"md"},
  "Massachusetts": {fr:"Massachusetts",abbr:"ma"},
  "Michigan":      {fr:"Michigan",abbr:"mi"},
  "Minnesota":     {fr:"Minnesota",abbr:"mn"},
  "Mississippi":   {fr:"Mississippi",abbr:"ms"},
  "Missouri":      {fr:"Missouri",abbr:"mo"},
  "Montana":       {fr:"Montana",abbr:"mt"},
  "Nebraska":      {fr:"Nebraska",abbr:"ne"},
  "Nevada":        {fr:"Nevada",abbr:"nv"},
  "New Hampshire": {fr:"New Hampshire",abbr:"nh"},
  "New Jersey":    {fr:"New Jersey",abbr:"nj"},
  "New Mexico":    {fr:"Nouveau Mexique",abbr:"nm"},
  "New York":      {fr:"New York",abbr:"ny"},
  "North Carolina":{fr:"Caroline du Nord",abbr:"nc"},
  "North Dakota":  {fr:"Dakota du Nord",abbr:"nd"},
  "Ohio":          {fr:"Ohio",abbr:"oh"},
  "Oklahoma":      {fr:"Oklahoma",abbr:"ok"},
  "Oregon":        {fr:"Oregon",abbr:"or"},
  "Pennsylvania":  {fr:"Pennsylvanie",abbr:"pa"},
  "Rhode Island":  {fr:"Rhode Island",abbr:"ri"},
  "South Carolina":{fr:"Caroline du Sud",abbr:"sc"},
  "South Dakota":  {fr:"Dakota du Sud",abbr:"sd"},
  "Tennessee":     {fr:"Tennessee",abbr:"tn"},
  "Texas":         {fr:"Texas",abbr:"tx"},
  "Utah":          {fr:"Utah",abbr:"ut"},
  "Vermont":       {fr:"Vermont",abbr:"vt"},
  "Virginia":      {fr:"Virginie",abbr:"va"},
  "Washington":    {fr:"Washington",abbr:"wa"},
  "West Virginia": {fr:"Virginie Occ.",abbr:"wv"},
  "Wisconsin":     {fr:"Wisconsin",abbr:"wi"},
  "Wyoming":       {fr:"Wyoming",abbr:"wy"},
};

const STATE_IMG = {
  "al":"Alabama - Flag Badge-01.png","ak":"Alaska - Flag Badge-01.png",
  "az":"Arizona - Flag Badge-01.png","ar":"Arkansas - Flag Badge-01.png",
  "ca":"California - Flag Badge-01.png","co":"Colorado - Flag Badge-01.png",
  "ct":"Connecticut - Flag Badge-01.png","de":"Delaware - Flag Badge.png",
  "fl":"Florida - Flag Badge-01.png","ga":"Georgia - Flag Badge.png",
  "hi":"Hawaii - Flag Badge-01.png","id":"Idaho - Flag Badge-01.png",
  "il":"Illinois - Flag Badge-01.png","in":"Indiana - Flag Badge-01.png",
  "ia":"Iowa - Flag Badge-01.png","ks":"Kansas - Flag Badge-01.png",
  "ky":"Kentucky - Flag Badge-01.png","la":"Louisiana - Flag Badge-01.png",
  "me":"Maine - Flag Badge-01.png","md":"Maryland - Flag Badge-01.png",
  "ma":"Massachussets - Flag Badge-01.png","mi":"Michigan - Flag Badge-01.png",
  "mn":"Minnesota - Flag Badge-01.png","ms":"Mississippi - Flag Badge-01.png",
  "mo":"Missouri - Flag Badge-01.png","mt":"Montana - Flag Badge-01.png",
  "ne":"Nebraska - Flag Badge-01-01.png","nv":"Nevada - Flag Badge-01.png",
  "nh":"New Hampshire - Flag Badge-01.png","nj":"New Jersey - Flag Badge-01.png",
  "nm":"New Mexico - Flag Badge-01.png","ny":"New York - Flag Badge-01.png",
  "nc":"North Carolina - Flag Badge.png","nd":"North Dakota - Flag Badge-01.png",
  "oh":"Ohio - Flag Badge.png","ok":"Oklahoma - Flag Badge-01.png",
  "or":"Oregon - Flag Badge-01.png","pa":"Pennsylvania - Flag Badge-01-01.png",
  "ri":"Rhode Island - Flag Badge-01.png","sc":"South Carolina - Flag Badge.png",
  "sd":"South Dakota - Flag Badge-01.png","tn":"Tennessee - Flag Badge-01-01.png",
  "tx":"Texas - Flag Badge.png","ut":"Utah - Flag Badge-01.png",
  "vt":"Vermont - Flag Badge-01.png","va":"Virginia - Flag Badge-01-01.png",
  "wa":"Washington - Flag Badge-01.png","wv":"West Virginia - Flag Badge-01.png",
  "wi":"Wisconsin - Flag Badge-01.png","wy":"Wyoming - Flag Badge-01.png",
};

const WC = f => `https://commons.wikimedia.org/wiki/Special:FilePath/${f}?width=320`;
const FR_REGIONS = {
  "Île-de-France":              {fr:"Île-de-France",slug:"ile-de-france",flagUrl:WC("Flag_of_%C3%8Ele-de-France.svg")},
  "Centre-Val de Loire":        {fr:"Anjou",slug:"anjou",flagUrl:WC("Anjou_flag.svg")},
  "Bourgogne-Franche-Comté":    {fr:"Bourgogne",slug:"bourgogne",flagUrl:WC("Flag_of_Burgundy.svg")},
  "Normandie":                  {fr:"Normandie",slug:"normandie",flagUrl:WC("Normandie_flag.svg")},
  "Hauts-de-France":            {fr:"Nord-Pas-de-Calais",slug:"nord-pas-de-calais",flagUrl:WC("Flag_of_Nord-Pas-de-Calais.svg")},
  "Grand Est":                  {fr:"Alsace",slug:"alsace",flagUrl:WC("Flag_of_Alsace.svg")},
  "Pays de la Loire":           {fr:"Poitou",slug:"poitou",flagUrl:WC("Blason_Poitou.svg")},
  "Bretagne":                   {fr:"Bretagne",slug:"bretagne",flagUrl:WC("Flag_of_Brittany.svg")},
  "Nouvelle-Aquitaine":         {fr:"Aquitaine",slug:"aquitaine",flagUrl:WC("Flag_of_Guyenne_and_Gascony.svg")},
  "Occitanie":                  {fr:"Occitanie",slug:"occitanie",flagUrl:WC("Cross_of_Languedoc.svg")},
  "Auvergne-Rhône-Alpes":       {fr:"Auvergne",slug:"auvergne",flagUrl:WC("Flag_of_Auvergne.svg")},
  "Provence-Alpes-Côte d'Azur": {fr:"Provence",slug:"provence",flagUrl:WC("Flag_of_Provence.svg")},
  "Corse":                      {fr:"Corse",slug:"corse",flagUrl:WC("Flag_of_Corsica.svg")},
};

const REGION_IMG = {
  "ile-de-france":"Ile de France - Flag Badge-01.png",
  "anjou":"Anjou - Flag Badge.png",
  "bourgogne":"Bourgogne - Flag Badge-01.png",
  "normandie":"Normandie - Flag Badge-01.png",
  "nord-pas-de-calais":"Nord Pas De Calais - Flag Badge.png",
  "alsace":"Alsace - Flag Badge.png",
  "poitou":"Poitou - Flag Badge-01.png",
  "bretagne":"Bretagne - Flag Badge.png",
  "aquitaine":"Aquitaine - Flag Badge.png",
  "occitanie":"Occitanie - Flag Badge.png",
  "auvergne":"Auvergne - Flag Badge.png",
  "provence":"PACA - Flag Badge-01.png",
  "corse":"Corse - Flag Badge.png",
};

function normalizeLookupKey(value){
  return (value ?? "")
    .normalize("NFD").replace(/[\u0300-\u036f]/g,"")
    .replace(/\s+/g," ").trim().toLowerCase();
}

const US_STATES_BY_KEY = Object.fromEntries(
  Object.entries(US_STATES).map(([name,data]) => [normalizeLookupKey(name),data])
);
const FR_REGIONS_BY_KEY = Object.fromEntries(
  Object.entries(FR_REGIONS).map(([name,data]) => [normalizeLookupKey(name),data])
);

function resolveStateData(feature){
  const fips = String(feature.id ?? "").padStart(2,"0");
  const name = FIPS_STATE[fips] ?? feature.properties?.name ?? "";
  return US_STATES_BY_KEY[normalizeLookupKey(name)] ?? {fr:name,search:name};
}
function resolveRegionData(feature){
  const rawName = feature.properties?.nom ?? feature.properties?.name ?? "";
  return FR_REGIONS_BY_KEY[normalizeLookupKey(rawName)] ?? {fr:rawName,search:rawName};
}

const wrap      = document.getElementById("km-wrap");
const svgEl     = document.getElementById("km-svg");
const ttClose   = document.getElementById("km-tt-close");
const ttEl      = document.getElementById("km-tooltip");
const ttFlagWrap= document.getElementById("km-tt-flag-wrap");
const ttFlag    = document.getElementById("km-tt-flag");
const ttBanner  = document.getElementById("km-tt-banner");
const ttName    = document.getElementById("km-tt-name");
const ttLink    = document.getElementById("km-tt-link");
const hint      = document.getElementById("km-hint");
const loadingEl = document.getElementById("km-loading");
const errorEl   = document.getElementById("km-error");
const errorMsg  = document.getElementById("km-error-msg");
const retryBtn  = document.getElementById("km-retry");

const HOVER_CAPABLE = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

let detailMode    = false;
let statesLoaded  = false;
let regionsLoaded = false;
let curT          = d3.zoomIdentity;
let W = 0, H = 0;

const svg = d3.select(svgEl);
svg.append("rect").attr("width","100%").attr("height","100%").attr("fill","#ffffff");

const gAll     = svg.append("g").attr("id","km-all");
const gGlobe   = gAll.append("g");
const gWorld   = gAll.append("g");
const gStates  = gAll.append("g").style("display","none");
const gRegions = gAll.append("g").style("display","none");

const proj    = d3.geoNaturalEarth1();
const pathGen = d3.geoPath(proj);

function sizeProjection(){
  W = wrap.clientWidth  || 800;
  H = wrap.clientHeight || 520;
  proj.scale(Math.min(W/5.8, H/3.1)).translate([W/2, H/2]);
}
sizeProjection();

const sphere = gGlobe.append("path")
  .datum({type:"Sphere"})
  .attr("fill","rgba(160,215,235,0.52)")
  .attr("stroke","rgba(18,38,87,0.12)")
  .attr("stroke-width",0.8);

const graticule = gGlobe.append("path")
  .datum(d3.geoGraticule().step([30,30])())
  .attr("fill","none")
  .attr("stroke","rgba(18,38,87,0.08)")
  .attr("stroke-width",0.5);

function drawGlobe(){ sphere.attr("d",pathGen); graticule.attr("d",pathGen); }
drawGlobe();

const gParis    = svg.append("g");
const parisRing = gParis.append("circle")
  .attr("r",7).attr("fill","none")
  .attr("stroke","#F2C02B").attr("stroke-width",1.8)
  .attr("class","km-paris-ring").style("pointer-events","none");
const parisDot  = gParis.append("circle")
  .attr("r",5).attr("fill","#F2C02B")
  .attr("stroke","#fff").attr("stroke-width",1.4)
  .style("pointer-events","none");
const parisHit  = gParis.append("circle")
  .attr("r",15).attr("fill","transparent")
  .style("pointer-events","all").style("cursor","pointer");

let parisBase = proj(CFG.paris);
function updateParis(){
  parisBase = proj(CFG.paris);
  const [x,y] = curT.apply(parisBase);
  for (const c of [parisRing,parisDot,parisHit]) c.attr("cx",x).attr("cy",y);
}
updateParis();

const OCEAN_PTS = [
  {lon:-165,lat:25},{lon:-128,lat:-32},{lon:-33,lat:38},{lon:-20,lat:-28},{lon:72,lat:-18},
];
const gOceanLabels = svg.append("g").attr("id","km-ocean-labels").style("pointer-events","none");
const oceanTexts = OCEAN_PTS.map(() =>
  gOceanLabels.append("text")
    .text("Komorebi")
    .attr("text-anchor","middle").attr("dominant-baseline","middle")
    .attr("fill","rgba(18,38,87,0.18)")
    .attr("font-family","'Helvetica Neue',Helvetica,Arial,sans-serif")
    .attr("font-style","italic").attr("font-weight","300")
    .attr("font-size","14px").attr("letter-spacing","0.14em")
    .style("user-select","none")
);
const oceanBases = OCEAN_PTS.map(d => proj([d.lon,d.lat]));

function updateOceanLabels(){
  OCEAN_PTS.forEach((d,i) => {
    const base = proj([d.lon,d.lat]);
    oceanBases[i] = base;
    if (!base){ oceanTexts[i].style("display","none"); return; }
    const [x,y] = curT.apply(base);
    oceanTexts[i].style("display",null).attr("x",x).attr("y",y);
  });
}
updateOceanLabels();

const CITIES = [
  {fr:"Amsterdam",lon:4.9041,lat:52.3676,img:"Amsterdam - Flag Badge-01.png"},
  {fr:"Athènes",lon:23.7275,lat:37.9838,img:"Athens - Flag Badge-01.png"},
  {fr:"Berlin",lon:13.4050,lat:52.5200,img:"Berlin - Flag Badge.png"},
  {fr:"Berne",lon:7.4458,lat:46.9480,img:"Bern - Flag Badge.png"},
  {fr:"Bruxelles",lon:4.3517,lat:50.8503,img:"Bruxelles - Flag Badge-01.png"},
  {fr:"Le Cap",lon:18.4241,lat:-33.9249,img:"Cape Town - Flag Badge-01.png"},
  {fr:"Jérusalem",lon:35.2137,lat:31.7683,img:"Jerusalem - Flag Badge.png"},
  {fr:"Kiev",lon:30.5234,lat:50.4501,img:"Kyiv - Flag Badge.png"},
  {fr:"Londres",lon:-0.1278,lat:51.5074,img:"London - Flag Badge-01.png"},
  {fr:"Madrid",lon:-3.7038,lat:40.4168,img:"Madrid - Flag Badge-01.png"},
  {fr:"Rome",lon:12.4964,lat:41.9028,img:"Rome - Flag Badge-01.png"},
  {fr:"Stockholm",lon:18.0686,lat:59.3293,img:"Stockholm - Flag Badge-01.png"},
  {fr:"Tokyo",lon:139.6917,lat:35.6895,img:"Tokyo Metropolis - Flag Badge.png"},
  {fr:"Washington DC",lon:-77.0369,lat:38.9072,img:"Washington DC - Flag Badge-01.png"},
];

const gCities = svg.append("g").attr("id","km-cities");
let citiesVisible = false;

const cityMarkers = CITIES.map(city => {
  const info = {name:city.fr, href:searchUrl(city.fr), img:imgUrl(CFG.cityImgBase,city.img,null)};
  const g    = gCities.append("g").style("display","none");
  const ring = g.append("circle").attr("r",2).attr("fill","none")
    .attr("stroke","#F2C02B").attr("stroke-width",1.2)
    .attr("class","km-city-ring").style("pointer-events","none");
  const dot  = g.append("circle").attr("r",3).attr("fill","#F2C02B")
    .attr("stroke","#fff").attr("stroke-width",1).style("pointer-events","none");
  const hit  = g.append("circle").attr("r",10).attr("fill","transparent")
    .style("pointer-events","all").style("cursor","pointer");
  hit.on("mouseenter",ev=>{ if(HOVER_CAPABLE) showTT(ev,info); })
     .on("mousemove", ev=>{ if(HOVER_CAPABLE) moveTT(ev); })
     .on("mouseleave",()=>{ if(HOVER_CAPABLE) hideTT(); })
     .on("click",ev=>{
       ev.stopPropagation();
       if(HOVER_CAPABLE){ openSearch(info.href); }
       else { clearTouchSel(); showTT(ev,info); }
     });
  return {city,ring,dot,hit,g};
});

function updateCities(){
  for (const m of cityMarkers){
    if (!citiesVisible){ m.g.style("display","none"); continue; }
    const pt = proj([m.city.lon,m.city.lat]);
    if (!pt){ m.g.style("display","none"); continue; }
    const [x,y] = curT.apply(pt);
    m.g.style("display",null);
    for (const el of [m.ring,m.dot,m.hit]) el.attr("cx",x).attr("cy",y);
  }
}

const zoom = d3.zoom().scaleExtent([1,10]).on("zoom",onZoom);
svg.call(zoom).on("dblclick.zoom",null);

function applyStroke(k){
  gWorld  .selectAll("path").attr("stroke-width",0.5/k);
  gStates .selectAll("path").attr("stroke-width",0.9/k);
  gRegions.selectAll("path").attr("stroke-width",0.9/k);
}

function onZoom(event){
  curT = event.transform;
  gAll.attr("transform",curT);
  applyStroke(curT.k);
  updateParis();
  updateOceanLabels();
  citiesVisible = curT.k >= CFG.cityZoom;
  updateCities();
  setDetail(curT.k);
}

function applyLayerVisibility(){
  gStates .style("display", detailMode && statesLoaded  ? null : "none");
  gRegions.style("display", detailMode && regionsLoaded ? null : "none");
  gWorld.selectAll("path[data-iso='US']").style("display", detailMode && statesLoaded  ? "none" : null);
  gWorld.selectAll("path[data-iso='FR']").style("display", detailMode && regionsLoaded ? "none" : null);
}

function setDetail(k){
  const next = detailMode ? (k >= CFG.detailExit) : (k >= CFG.detailZoom);
  if (next === detailMode) return;
  detailMode = next;
  hint.textContent = detailMode ? DETAIL_HINT : (HOVER_CAPABLE ? DEFAULT_HINT : TOUCH_HINT);
  applyLayerVisibility();
}

document.getElementById("km-btn-in").addEventListener("click",
  () => svg.transition().duration(280).call(zoom.scaleBy,1.7));
document.getElementById("km-btn-out").addEventListener("click",
  () => svg.transition().duration(280).call(zoom.scaleBy,1/1.7));
document.getElementById("km-btn-reset").addEventListener("click",
  () => svg.transition().duration(450).call(zoom.transform,d3.zoomIdentity));

function setTTImage(url){
  if (url){
    ttFlagWrap.style.display = "block";
    ttBanner.style.display   = "none";
    ttFlag.src = url;
  } else {
    ttFlagWrap.style.display = "none";
    ttBanner.style.display   = "flex";
  }
}
ttFlag.addEventListener("error", () => {
  ttFlagWrap.style.display = "none";
  ttBanner.style.display   = "flex";
});

function showTT(event,info){
  setTTImage(info.img);
  ttName.textContent = info.name;
  ttLink.href = info.href;
  ttEl.classList.add("visible");
  ttEl.classList.toggle("interactive",!HOVER_CAPABLE);
  moveTT(event);
}
function hideTT(){ ttEl.classList.remove("visible","interactive"); }
function moveTT(event){
  const rect = wrap.getBoundingClientRect();
  const tw = ttEl.offsetWidth  || 210;
  const th = ttEl.offsetHeight || 170;
  const px = event.clientX - rect.left;
  const py = event.clientY - rect.top;
  let x = px - tw/2;
  let y = py - th - 18;
  x = Math.max(8, Math.min(x, W-tw-8));
  if (y < 8) y = Math.min(H-th-8, py+22);
  y = Math.max(8, Math.min(y, H-th-8));
  ttEl.style.transform = `translate(${x}px,${y}px)`;
}

let lastOpen = 0;
function openSearch(href){
  const now = Date.now();
  if (now - lastOpen < 400) return;
  lastOpen = now;
  window.open(href,"_blank","noopener");
}

let touchSel = null;
function clearTouchSel(){
  if (touchSel){ touchSel.node.setAttribute("fill",touchSel.restFill); touchSel=null; }
}

function bindInteraction(selection,restFill,hoverFill,build){
  selection
    .style("cursor","pointer")
    .attr("fill",restFill)
    .on("mouseenter",function(ev,d){
      if (!HOVER_CAPABLE) return;
      this.setAttribute("fill",hoverFill);
      showTT(ev,build(d));
    })
    .on("mousemove",function(ev){ if(HOVER_CAPABLE) moveTT(ev); })
    .on("mouseleave",function(){
      if (!HOVER_CAPABLE) return;
      this.setAttribute("fill",restFill);
      hideTT();
    })
    .on("click",function(ev,d){
      ev.stopPropagation();
      const info = build(d);
      if (HOVER_CAPABLE){
        openSearch(info.href);
      } else {
        clearTouchSel();
        this.setAttribute("fill",hoverFill);
        touchSel = {node:this,restFill};
        showTT(ev,info);
      }
    });
}

svg.on("click",() => { if(!HOVER_CAPABLE){ clearTouchSel(); hideTT(); } });

const PARIS_INFO = {name:"Paris", href:searchUrl("Paris"), img:parisFlagUrl()};
parisHit
  .on("mouseenter",ev=>{ if(HOVER_CAPABLE) showTT(ev,PARIS_INFO); })
  .on("mousemove", ev=>{ if(HOVER_CAPABLE) moveTT(ev); })
  .on("mouseleave",()=>{ if(HOVER_CAPABLE) hideTT(); })
  .on("click",ev=>{
    ev.stopPropagation();
    if(HOVER_CAPABLE){ openSearch(PARIS_INFO.href); }
    else { clearTouchSel(); showTT(ev,PARIS_INFO); }
  });

function showLoading(){ loadingEl.hidden=false; errorEl.hidden=true; }
function hideLoading(){ loadingEl.hidden=true; }
function showError(msg){ loadingEl.hidden=true; errorMsg.textContent=msg; errorEl.hidden=false; }
retryBtn.addEventListener("click",loadAll);
ttClose.addEventListener("click", ev => { ev.stopPropagation(); clearTouchSel(); hideTT(); });

async function fetchGeo(urls){
  let lastErr;
  for (const url of urls){
    try {
      const res = await fetch(url,{mode:"cors"});
      if (!res.ok) throw new Error("HTTP "+res.status);
      return await res.json();
    } catch(err){ lastErr=err; console.warn("Komorebi map — source unavailable:",url,err); }
  }
  throw lastErr ?? new Error("No source");
}

async function loadAll(){
  showLoading();
  let world;
  try { world = await fetchGeo(GEO.world); }
  catch(err){
    console.error("Komorebi map — map load failed:",err);
    showError("La carte n'a pas pu être chargée. Vérifiez votre connexion, puis réessayez.");
    return;
  }
  buildWorld(world);
  hideLoading();
  fetchGeo(GEO.states)
    .then(topo => {
      const geo = topojson.feature(topo,topo.objects.states);
      buildStates(geo); statesLoaded=true; applyLayerVisibility();
    })
    .catch(err => console.warn("Komorebi map — US states unavailable:",err));
  fetchGeo(GEO.regions)
    .then(data => { buildRegions(data); regionsLoaded=true; applyLayerVisibility(); })
    .catch(err => console.warn("Komorebi map — FR regions unavailable:",err));
}

function isoOf(d){
  const p = d.properties ?? {};
  return p.ISO_A2==="-99" ? p.ISO_A2_EH : p.ISO_A2;
}

function buildWorld(geo){
  gWorld.selectAll("path").remove();
  const all = gWorld.selectAll("path")
    .data(geo.features).join("path")
      .attr("class","km-shape km-country")
      .attr("d",pathGen)
      .attr("stroke","rgba(160,125,60,0.4)")
      .attr("stroke-width",0.5/curT.k)
      .attr("stroke-linejoin","round")
      .attr("data-iso",d=>isoOf(d))
      .attr("fill",d=>COUNTRIES[isoOf(d)]?"#dcc89a":"#c8b47e")
      .style("pointer-events","none");
  const active = all.filter(d=>COUNTRIES[isoOf(d)]);
  active.style("pointer-events",null);
  bindInteraction(active,"#dcc89a","#F2C02B",d=>{
    const iso=isoOf(d), data=COUNTRIES[iso];
    return {name:data.fr, href:countryUrl(d,data), img:flagCdn(iso)};
  });
  applyLayerVisibility();
}

function buildStates(geo){
  gStates.selectAll("path").remove();
  const paths = gStates.selectAll("path")
    .data(geo.features).join("path")
      .attr("class","km-shape km-state")
      .attr("d",pathGen)
      .attr("stroke","rgba(160,125,60,0.55)")
      .attr("stroke-width",0.9/curT.k)
      .attr("stroke-linejoin","round");
  bindInteraction(paths,"#dcc89a","#F2C02B",d=>{
    const sd=resolveStateData(d);
    return {name:sd.fr, href:stateUrl(d,sd), img:sd.abbr?stateFlagUrl(sd.abbr):null};
  });
}

function buildRegions(geo){
  gRegions.selectAll("path").remove();
  const paths = gRegions.selectAll("path")
    .data(geo.features).join("path")
      .attr("class","km-shape km-region")
      .attr("d",pathGen)
      .attr("stroke","rgba(160,125,60,0.55)")
      .attr("stroke-width",0.9/curT.k)
      .attr("stroke-linejoin","round");
  bindInteraction(paths,"#dcc89a","#F2C02B",d=>{
    const rd=resolveRegionData(d);
    return {name:rd.fr, href:regionUrl(d,rd), img:regionFlagUrl(rd.slug,rd.flagUrl??null)};
  });
}

function redraw(){
  sizeProjection(); drawGlobe();
  gWorld  .selectAll("path").attr("d",pathGen);
  gStates .selectAll("path").attr("d",pathGen);
  gRegions.selectAll("path").attr("d",pathGen);
  updateParis(); updateOceanLabels(); updateCities();
}
let resizeRAF = 0;
new ResizeObserver(() => {
  cancelAnimationFrame(resizeRAF);
  resizeRAF = requestAnimationFrame(redraw);
}).observe(wrap);

hint.textContent = HOVER_CAPABLE ? DEFAULT_HINT : TOUCH_HINT;
loadAll();
} // end _kmInit
